import DOMPurify from 'dompurify';

// MUST match common/letter_html.py ALLOWED_TAGS/ATTRS byte-for-byte
// (Pitfall 7: sanitizer allowlist drift between TipTap, DOMPurify, and the
// server nh3 layer makes content silently disappear on save).
const ALLOWED_TAGS = ['p', 'h2', 'h3', 'ul', 'ol', 'li', 'strong', 'em', 'a', 'br', 'span'];
const ALLOWED_ATTR = ['href', 'data-variable'];
const ALLOWED_URI_REGEXP = /^(https?:|mailto:)/i;

/**
 * Outgoing scrub: belt-and-suspenders for editor HTML before it leaves the
 * client. Server-side sanitization is the real trust boundary.
 */
export function sanitizeHtml(html) {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP,
  });
}
